import { memo, useMemo } from 'react';
import { Button } from 'src/common/Button/Button';
import { Chip } from 'src/modules/common/components/Chip/Chip';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { FilterIcon } from 'src/modules/common/icons/FilterIcon';
import { Filter, FilterConfig } from 'src/utils/composeFilter';
import { CheckboxHandler } from 'src/modules/common/types/CheckboxHandler';

type Props = {
    filter: Filter;
    config: FilterConfig;
    handleFilterSidebarOpen: () => void;
    filterCloseHandler: CheckboxHandler;
    useTranslate: boolean;
    isMobile?: boolean;
}

export const FilterSidebarActions = memo(({
    config,
    filter,
    handleFilterSidebarOpen,
    filterCloseHandler,
    useTranslate = false,
    isMobile = false,
}: Props) => {
    const chips = useMemo(
        () => Object.entries(filter).filter(([name]) => config.find(([item]) => item === name)),
        [filter, config],
    );

    return (
        <div className="vss-filter-sidebar-actions">
            {!isMobile && (
                <Button
                    onClick={handleFilterSidebarOpen}
                    kind="tertiary"
                    size="lg"
                    reversed={true}
                >
                    <I18n messageId={MESSAGES.deviceGridActionFilter}/>

                    <div className="vss-filter-sidebar-actions__icon">
                        <FilterIcon/>
                    </div>
                </Button>
            )}

            {chips.length ? (
                <div className="vss-filter-sidebar-actions__chips">
                    {chips.map(([name, values]) => values.map((value) => (
                        <Chip key={`${name}${value}`} onClick={() => filterCloseHandler({ name, value })}>
                            {useTranslate ? <I18n messageId={value}/> : value}
                        </Chip>
                    )))}
                </div>
            ) : null}
        </div>
    );
});
